import { AninharView, menuRotas } from "../../../services/router";

export default function Rootview() {
    return (
        <div>
            <h1>MyGas</h1>
            {menuRotas.map((menu,idx)=>(
                <button key={idx} onClick={menu.eventOnClick} >{menu.text}</button>
            ))}
            
            <AninharView />
        </div>
    )
}